import { ASSISTANT_PAGE_PATH } from "components/AssistantPanel/constants";
import { MainNavigationMenuItem } from "components/MainNavigation/types";
import { REPOS_PAGE_URL } from "utils/spaceliftRepo";

export enum MainNavigationPrimaryMenuItemKeys {
  AiChat = "ai-chat",
  Dashboard = "dashboard",
  Launchpad = "launchpad",
  Notifications = "notifications",
  Stacks = "stacks",
  Blueprints = "blueprints",
  Registry = "registry",
  Runs = "runs",
  Spaces = "spaces",
  Resources = "resources",
  Policies = "policies",
  Contexts = "contexts",
  IntentProjects = "intent-projects",
  WorkerPools = "worker-pools",
  Integrations = "integrations",
  Plugins = "plugins",
  Flows = "flows",
  Billing = "billing",
  Usage = "usage",
  AuditTrail = "audit-trail",
  AccountSettings = "account-settings",
  ModuleRegistry = "module-registry",
  Providers = "providers",
  GPGKeys = "gpg-keys",
  AccountUsersSettings = "account-users-settings",
  TemplateWorkbench = "template-workbench",
  TemplatesMarketplace = "templates-marketplace",
  SpaceliftRepos = "spacelift-repos",
}

export const MAIN_NAVIGATION_PRIMARY_MENU_ITEMS: Record<
  MainNavigationPrimaryMenuItemKeys,
  MainNavigationMenuItem
> = {
  [MainNavigationPrimaryMenuItemKeys.AiChat]: {
    id: MainNavigationPrimaryMenuItemKeys.AiChat,
    title: "Infra Assistant",
    to: ASSISTANT_PAGE_PATH,
    routeRule: [ASSISTANT_PAGE_PATH],
  },
  [MainNavigationPrimaryMenuItemKeys.Dashboard]: {
    id: MainNavigationPrimaryMenuItemKeys.Dashboard,
    title: "Dashboard",
    to: "/dashboard",
    routeRule: ["/dashboard"],
  },
  [MainNavigationPrimaryMenuItemKeys.Launchpad]: {
    id: MainNavigationPrimaryMenuItemKeys.Launchpad,
    title: "LaunchPad",
    to: "/launchpad",
    routeRule: ["/launchpad"],
  },
  [MainNavigationPrimaryMenuItemKeys.Notifications]: {
    id: MainNavigationPrimaryMenuItemKeys.Notifications,
    title: "Notifications",
    to: "/notifications",
    routeRule: ["/notifications"],
  },
  [MainNavigationPrimaryMenuItemKeys.Stacks]: {
    id: MainNavigationPrimaryMenuItemKeys.Stacks,
    title: "Stacks",
    to: "/stacks",
    routeRule: ["/stacks", "/stack", "/new/stack"],
    htmlId: "stacks-navigation-item",
  },
  [MainNavigationPrimaryMenuItemKeys.Resources]: {
    id: MainNavigationPrimaryMenuItemKeys.Resources,
    title: "Resources",
    to: "/resources",
    routeRule: ["/resources"],
  },
  [MainNavigationPrimaryMenuItemKeys.Runs]: {
    id: MainNavigationPrimaryMenuItemKeys.Runs,
    title: "Runs",
    to: "/runs",
    routeRule: ["/runs"],
  },
  [MainNavigationPrimaryMenuItemKeys.Registry]: {
    id: MainNavigationPrimaryMenuItemKeys.Registry,
    title: "Registry",
    to: "/modules",
    routeRule: ["/modules", "/module", "/provider", "/gpg-key", "/new/module", "/shared-modules"],
  },
  [MainNavigationPrimaryMenuItemKeys.Contexts]: {
    id: MainNavigationPrimaryMenuItemKeys.Contexts,
    title: "Contexts",
    to: "/contexts",
    routeRule: ["/contexts", "/context", "/new/context"],
  },
  [MainNavigationPrimaryMenuItemKeys.Blueprints]: {
    id: MainNavigationPrimaryMenuItemKeys.Blueprints,
    title: "Blueprints",
    to: "/blueprints",
    routeRule: ["/blueprints", "/blueprint"],
  },
  [MainNavigationPrimaryMenuItemKeys.Spaces]: {
    id: MainNavigationPrimaryMenuItemKeys.Spaces,
    title: "Spaces",
    to: "/spaces",
    routeRule: ["/spaces"],
  },
  [MainNavigationPrimaryMenuItemKeys.Policies]: {
    id: MainNavigationPrimaryMenuItemKeys.Policies,
    title: "Policies",
    to: "/policies",
    routeRule: ["/policy", "/new/policy", "/policies"],
  },
  [MainNavigationPrimaryMenuItemKeys.Integrations]: {
    id: MainNavigationPrimaryMenuItemKeys.Integrations,
    title: "Integrations",
    to: "/integrations",
    routeRule: ["/integrations"],
  },
  [MainNavigationPrimaryMenuItemKeys.Plugins]: {
    id: MainNavigationPrimaryMenuItemKeys.Plugins,
    title: "Plugins",
    to: "/plugins",
    routeRule: ["/plugins"],
  },
  [MainNavigationPrimaryMenuItemKeys.Flows]: {
    id: MainNavigationPrimaryMenuItemKeys.Flows,
    title: "Flows",
    to: "/flows",
    routeRule: ["/flows"],
  },
  [MainNavigationPrimaryMenuItemKeys.Billing]: {
    id: MainNavigationPrimaryMenuItemKeys.Billing,
    title: "Billing",
    to: "/settings/billing",
    routeRule: ["/settings/billing"],
  },
  [MainNavigationPrimaryMenuItemKeys.Usage]: {
    id: MainNavigationPrimaryMenuItemKeys.Usage,
    title: "Usage",
    to: "/settings/usage",
    routeRule: ["/settings/usage"],
  },
  [MainNavigationPrimaryMenuItemKeys.WorkerPools]: {
    id: MainNavigationPrimaryMenuItemKeys.WorkerPools,
    title: "Worker Pools",
    to: "/worker-pools",
    routeRule: ["/worker-pools", "/worker-pool"],
  },
  [MainNavigationPrimaryMenuItemKeys.AuditTrail]: {
    id: MainNavigationPrimaryMenuItemKeys.AuditTrail,
    title: "Audit Trail",
    to: "/audit-trail",
    routeRule: ["/audit-trail"],
  },
  [MainNavigationPrimaryMenuItemKeys.AccountUsersSettings]: {
    id: MainNavigationPrimaryMenuItemKeys.AccountUsersSettings,
    title: "IAM",
    to: "/settings/users",
    routeRule: ["/settings/users"],
  },
  [MainNavigationPrimaryMenuItemKeys.AccountSettings]: {
    id: MainNavigationPrimaryMenuItemKeys.AccountSettings,
    title: "Settings",
    to: "/settings",
    routeRule: ["/settings"],
  },
  [MainNavigationPrimaryMenuItemKeys.IntentProjects]: {
    id: MainNavigationPrimaryMenuItemKeys.IntentProjects,
    title: "Intent Projects",
    to: "/intent-projects",
    routeRule: ["/intent-project", "/intent-projects"],
  },
  [MainNavigationPrimaryMenuItemKeys.ModuleRegistry]: {
    id: MainNavigationPrimaryMenuItemKeys.ModuleRegistry,
    title: "Module Registry",
    to: "/modules",
    routeRule: ["/modules", "/module", "/new/module"],
  },
  [MainNavigationPrimaryMenuItemKeys.Providers]: {
    id: MainNavigationPrimaryMenuItemKeys.Providers,
    title: "Providers",
    to: "/providers",
    routeRule: ["/provider", "/providers", "/new/provider"],
  },
  [MainNavigationPrimaryMenuItemKeys.GPGKeys]: {
    id: MainNavigationPrimaryMenuItemKeys.GPGKeys,
    title: "GPG Keys",
    to: "/gpg-keys",
    routeRule: ["/gpg-key", "/gpg-keys", "/new/gpg-key"],
  },
  [MainNavigationPrimaryMenuItemKeys.TemplateWorkbench]: {
    id: MainNavigationPrimaryMenuItemKeys.TemplateWorkbench,
    title: "Templates Workbench",
    to: "/templates-workbench",
    routeRule: ["/templates-workbench", "/template"],
  },
  [MainNavigationPrimaryMenuItemKeys.TemplatesMarketplace]: {
    id: MainNavigationPrimaryMenuItemKeys.TemplatesMarketplace,
    title: "Templates",
    to: "/templates",
    routeRule: (pathname) =>
      pathname.startsWith("/templates") && !pathname.startsWith("/templates-workbench"),
  },
  [MainNavigationPrimaryMenuItemKeys.SpaceliftRepos]: {
    id: MainNavigationPrimaryMenuItemKeys.SpaceliftRepos,
    title: "Repos",
    to: REPOS_PAGE_URL,
    routeRule: [REPOS_PAGE_URL],
  },
};
